import { render } from "./photoMenuComponent.vue?vue&type=template&id=d4e7332e&scoped=true"
import script from "./photoMenuComponent.vue?vue&type=script&lang=js"
export * from "./photoMenuComponent.vue?vue&type=script&lang=js"

import "./photoMenuComponent.vue?vue&type=style&index=0&id=d4e7332e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e7332e"]])

export default __exports__